import { render, staticRenderFns } from "./CrossDomainTags.vue?vue&type=template&id=6b082496&scoped=true&lang=pug&"
import script from "./CrossDomainTags.vue?vue&type=script&lang=js&"
export * from "./CrossDomainTags.vue?vue&type=script&lang=js&"
import style0 from "./CrossDomainTags.vue?vue&type=style&index=0&id=6b082496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b082496",
  null
  
)

export default component.exports